import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
`;

export const ContainerAlert = styled.div`
  z-index: 3;
  width: 100%;
  top: 85%;
  text-align: center;
  position: fixed;

  .ant-alert-error,
  .ant-alert-warning,
  .ant-alert-info,
  .ant-alert-success {
    z-index: 3;
    border: none;
    width: 50%;
    margin: auto;
    top: 93%;

    padding: 12px;
    background-color: #ffffff;
  }

  .ant-alert-success {
    border-left: solid #47d764;
    box-shadow: 0 0 1em #0d8f2752;
  }

  .ant-alert-info {
    border-left: solid #1890ff;
    box-shadow: 0 0 1em #0058a585;
  }

  .ant-alert-warning {
    border-left: solid #faad14;
    box-shadow: 0 0 1em #c9820066;
  }

  .ant-alert-error {
    border-left: solid #ff4d4f;
    box-shadow: 0 0 1em #af00005c;
  }

  .ant-alert-message {
    font-weight: 600;
  }

  .anticon svg {
    font-size: 17pt;
  }

  [data-icon='close'] {
    font-size: 10pt !important;
  }
`;
